import './App.css';
import './styles/main.scss';
import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Routes from './Routes/Router';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorPage: false
    };
    this.renderPrivateRoute = this.renderPrivateRoute.bind(this);
  }

  renderErrorPage = () => {
    this.setState({
      errorPage: true
    });
  };

  renderPrivateRoute(rest) {
    let isLoggedIn = false;
    if (!isLoggedIn) {
      delete rest.component;
      rest.render = () => <Redirect to='/' />;
    }

    return <Route {...rest} />;
  }

  render() {
    return (
      <React.Fragment>
        <div className={`App ${this.props.location.pathname === '/' ? 'login-app' : null}`}>
          <Switch>
            {Routes.map((routeData) => {
              return routeData.isProtectedRoute ? (
                this.renderPrivateRoute({
                  key: `${routeData.title}-${routeData.path}`,
                  ...routeData
                })
              ) : (
                <Route key={`${routeData.title}-${routeData.path}`} {...routeData} />
              );
            })}
          </Switch>
        </div>
      </React.Fragment>
    );
  }
}
